import { requestWithToken } from '../../utilities/request';
const path = '/api/private/fields';

/**
 * お知らせ掲示板一覧取得API
 * @param {string}fieldId : 現場ID
 * @param {object}params : クエリパラメーター
 * */
const fetchFieldBulletinBoardList = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_bulletin_boards/list`),
    params,
  });
};

/**
 * お知らせ掲示板詳細取得API
 * @param {string}fieldId : 現場ID
 * @param {object}field_bulletin_board_id : お知らせID
 * */
const fetchFieldBulletinBoard = (fieldId, field_bulletin_board_id) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldId}/field_bulletin_boards/${field_bulletin_board_id}`
    ),
  });
};

/**
 * お知らせ掲示板既読API
 * @param {string}fieldId : 現場ID
 * @param {object}field_bulletin_board_id : お知らせID
 * */
const registerAlreadyRead = (fieldId, field_bulletin_board_id) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(
      `/${fieldId}/field_bulletin_boards/${field_bulletin_board_id}/read`
    ),
  });
};

/**
 * お知らせ掲示板登録API
 * @param {string}fieldId : 現場ID
 * @param {object}data : リクエストボディ
 * */
const registerFieldBulletinBoard = (fieldId, data) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/field_bulletin_boards`),
    data,
  });
};

/**
 * お知らせ掲示板ファイル登録API
 * @param {string}fieldId : 現場ID
 * @param {object}data : リクエストボディ
 * */
const registerTempFile = (fieldId, data) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/field_bulletin_boards/temp_files`),
    data,
  });
};

/**
 * お知らせ掲示板更新API
 * @param {string} fieldId : 現場ID
 * @param {string} fieldBulletinBoardId : 現場掲示板ID
 * @param {object} data : リクエストボディ
 * */
const updateFieldBulletinBoard = (fieldId, fieldBulletinBoardId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(
      `/${fieldId}/field_bulletin_boards/${fieldBulletinBoardId}`
    ),
    data,
  });
};

/**
 * お知らせ掲示板削除API
 * @param {string} fieldId : 現場ID
 * @param {string} fieldBulletinBoardId : 現場掲示板ID
 * @param {object} data : リクエストボディ
 * */
const deleteFieldBulletinBoard = (fieldId, fieldBulletinBoardId, data) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(
      `/${fieldId}/field_bulletin_boards/${fieldBulletinBoardId}`
    ),
    data,
  });
};

/**
 * お知らせ掲示板公開停止API
 * @param {string}fieldId 現場ID
 * @param {string}boardId 現場掲示板ID
 * @param {string}locakVersion ロックバージョン(競合判断用)
 * */
const stopFieldBulletinBoard = (fieldId, boardId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/field_bulletin_boards/${boardId}/stop`),
    data,
  });  
}

/**
 * お知らせ掲示板ファイル取得API
 * @param {string}fieldId : 現場ID
 * @param {string}boardId : 現場掲示板ID
 * @param {string}documentId : 添付ファイルID
 * */
const downloadFile = (fieldId, boardId, documentId) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `/${fieldId}/field_bulletin_boards/${boardId}/field_bulletin_board_documents/${documentId}/presigned_url`
    ),
  });
};

export const FieldBulletinBoardsApi = {
  fetchFieldBulletinBoardList,
  fetchFieldBulletinBoard,
  registerAlreadyRead,
  registerFieldBulletinBoard,
  registerTempFile,
  updateFieldBulletinBoard,
  deleteFieldBulletinBoard,
  stopFieldBulletinBoard,
  downloadFile,
};

export default FieldBulletinBoardsApi;



// WEBPACK FOOTER //
// ./src/services/fieldBulletinBoard/FieldBulletinBoardsApi.js